/**
 * @author AUTHOR_NAME
 * @email AUTHOR_EMAIL
 * @create date
 * @modify date
 * @desc withAllContexts HOC will send all the necessary Context such as AlertContext,
 * DialogContext, BackdropContext and DrawerContext as a prop.
 */

import React from "react";
import {
	AlertContext,
	DialogContext,
	BackdropContext,
	DrawerContext,
	DrawerMeetingContext,
	AVCShowContext,
	FirebaseContext
} from "../contexts";

const withAllContexts = (Component) => (props) => {
	const alert = React.useContext(AlertContext);
	const dialog = React.useContext(DialogContext);
	const backDrop = React.useContext(BackdropContext);
	const drawer = React.useContext(DrawerContext);
	const AVCMeeting = React.useContext(DrawerMeetingContext);
	const AVCShowList = React.useContext(AVCShowContext);
	const PushNotification = React.useContext(FirebaseContext);
	return (
		<Component
			{...props}
			alert={alert}
			dialog={dialog}
			backDrop={backDrop}
			drawer={drawer}
			// queryParams={queryParams}
			AVCShowList={AVCShowList}
			AVCMeeting={AVCMeeting}
			PushNotification={PushNotification}
		>
			{props.children}
		</Component>
	);
};

export default withAllContexts;
